"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = function _default(x) {
  return function () {
    return x;
  };
};
exports.default = _default;